{
  "title": "Set up your school",
  "description": "Four steps turn an empty school into a working one. This card disappears for good once they are done.",
  "progress": "{{done}} of {{total}} done",
  "hide": "Hide this",
  "done": "Done",
  "steps": {
    "class": {
      "label": "Create a class",
      "hint": "A class is the group everything else is taught to.",
      "action": "Open classes"
    },
    "members": {
      "label": "Invite members",
      "hint": "Teachers, pupils and parents join by invitation or with a class join code.",
      "action": "Open members"
    },
    "lesson": {
      "label": "Create your first lesson",
      "hint": "Lessons live inside a course — open one and add a lesson to it.",
      "action": "Open courses"
    },
    "homework": {
      "label": "Assign your first homework",
      "hint": "Give a class something to hand in, and the gradebook starts filling itself.",
      "action": "Open homework"
    }
  }
}
